import EditFieldImageUpload from '@/components/Vehicles/EditFieldImageUpload'
import { BFormInput } from 'bootstrap-vue'
import { sanitizeModel } from '@/common/utils/modelDecorator'

export default {
  computed: {
    routeId() {
      return this.$route.query?.id || null
    },
    vehiclesModel() {
      return sanitizeModel({
        title: 'Vehicles',
        endpoint: this.$appConfig.api.baseUrl + 'companies/' + this.profile.company_id + '/vehicles',
        allowNew: true,
        editInPlace: true,
        localEdit: true,
        allowDelete: true,
        // editBottomSlot: () => import('@/components/Vehicles/EditBottomSlot'),
        fields: [
          {
            key: 'id',
            sortable: true
          },
          {
            key: 'reference',
            sortable: true,
            editable: true,
            required: true,
            label: this.$gettext('Reference'),
            type: 'text',
            default: ''
          },
          {
            key: 'plate_number',
            sortable: true,
            editable: true,
            label: this.$gettext('Plate Number'),
            default: null,
            componentEdit: (value, key, item) => {
              return {
                is: BFormInput,
                props: {
                  required: !!(item.vehicle_type_id && this.vehicleTypes.find(x => x.id === item.vehicle_type_id).is_registrable),
                  size: 'sm',
                  type: 'text'
                },
                on: {
                  input: (value) => {
                    item[key] = value || null
                  }
                }
              }
            }
          },
          {
            key: 'vehicle_type_id',
            sortable: true,
            editable: true,
            required: true,
            label: this.$gettext('Vehicle Type'),
            type: 'select',
            options: [
              {
                text: this.$gettext('-- Select an option --'),
                value: null
              },
              ...this.vehicleTypesSelect
            ],
            formatter: (value, key, item) => {
              return item.vehicle_type.name
            }
          },
          {
            key: 'insurance_expiration_date',
            sortable: true,
            editable: true,
            label: this.$gettext('Insurance Exp.'),
            type: 'plainDate',
            formatter: (value, key, item) => {
              return this.$options.filters.tabledate(value, 'UTC', this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'vehicle_card_picture',
            label: this.$gettext('Vehicle Card'),
            editable: true,
            formatter: (value, key, item) => {
              let html = ''
              if (value) {
                html = `<a href="${value}" target="_blank">${this.$gettext('YES')}</a>`
              } else {
                html = this.$gettext('NO')
              }
              return html
            },
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldImageUpload,
                props: {
                  item,
                  field: 'vehicle_card_picture'
                },
                on: {
                  update: (result) => {
                    item[key] = result[key]
                  }
                }
              }
            }
          },
          {
            key: 'insurance_card_picture',
            label: this.$gettext('Insurance Card'),
            editable: true,
            formatter: (value, key, item) => {
              let html = ''
              if (value) {
                html = `<a href="${value}" target="_blank">${this.$gettext('YES')}</a>`
              } else {
                html = this.$gettext('NO')
              }
              return html
            },
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldImageUpload,
                props: {
                  item,
                  field: 'insurance_card_picture'
                },
                on: {
                  update: (result) => {
                    item[key] = result[key]
                  }
                }
              }
            }
          },
          {
            key: 'active',
            type: 'numericBoolean',
            editable: true,
            label: this.$gettext('Enabled'),
            class: 'text-center',
            default: 1
          }
        ],
        filters: [
          'id',
          'reference',
          'plate_number'
        ],
        includes: [
          'vehicle_type'
        ]
      })
    },
    userVehiclesModel() {
      return sanitizeModel({
        title: 'Vehicles',
        endpoint: this.$appConfig.api.baseUrl + 'users/{id}/vehicles',
        allowNew: true,
        editInPlace: true,
        localEdit: true,
        allowDelete: true,
        fields: [
          {
            key: 'id',
            sortable: true
          },
          {
            key: 'reference',
            sortable: true,
            editable: true,
            required: true,
            label: this.$gettext('Reference'),
            type: 'text',
            default: ''
          },
          {
            key: 'plate_number',
            sortable: true,
            editable: true,
            label: this.$gettext('Plate Number'),
            default: null,
            componentEdit: (value, key, item) => {
              return {
                is: BFormInput,
                props: {
                  required: !!(item.vehicle_type_id && this.vehicleTypes.find(x => x.id === item.vehicle_type_id).is_registrable),
                  size: 'sm',
                  type: 'text'
                },
                on: {
                  input: (value) => {
                    item[key] = value || null
                  }
                }
              }
            }
          },
          {
            key: 'vehicle_type_id',
            sortable: true,
            editable: true,
            required: true,
            label: this.$gettext('Vehicle Type'),
            type: 'select',
            options: [
              {
                text: this.$gettext('-- Select an option --'),
                value: null
              },
              ...this.vehicleTypesSelect
            ],
            formatter: (value, key, item) => {
              return item.vehicle_type.name
            }
          },
          {
            key: 'insurance_expiration_date',
            sortable: true,
            editable: true,
            label: this.$gettext('Insurance Exp.'),
            type: 'plainDate',
            formatter: (value, key, item) => {
              return this.$options.filters.tabledate(value, 'UTC', this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'vehicle_card_picture',
            label: this.$gettext('Vehicle Card'),
            editable: true,
            formatter: (value, key, item) => {
              let html = ''
              if (value) {
                html = `<a href="${value}" target="_blank">${this.$gettext('YES')}</a>`
              } else {
                html = this.$gettext('NO')
              }
              return html
            },
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldImageUpload,
                props: {
                  item,
                  field: 'vehicle_card_picture'
                },
                on: {
                  update: (result) => {
                    item[key] = result[key]
                  }
                }
              }
            }
          },
          {
            key: 'insurance_card_picture',
            label: this.$gettext('Insurance Card'),
            editable: true,
            formatter: (value, key, item) => {
              let html = ''
              if (value) {
                html = `<a href="${value}" target="_blank">${this.$gettext('YES')}</a>`
              } else {
                html = this.$gettext('NO')
              }
              return html
            },
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldImageUpload,
                props: {
                  item,
                  field: 'insurance_card_picture'
                },
                on: {
                  update: (result) => {
                    item[key] = result[key]
                  }
                }
              }
            }
          },
          {
            key: 'active',
            type: 'numericBoolean',
            editable: true,
            label: this.$gettext('Enabled'),
            class: 'text-center',
            default: 1
          }
        ],
        filters: [
          'id',
          'reference',
          'plate_number'
        ],
        includes: [
          'vehicle_type'
        ],
        exclude: [
          'id'
        ]
      })
    }
  }
}
